import { App, Button, Card, Collapse, Result, Spin, theme, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import useInvoiceProfiles from 'src/hooks/useInvoiceProfiles'
import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { useLanguage } from 'src/providers/LanguageProvider';
import InvoiceForm from 'src/pages/invoice/InvoiceForm';
import InvoiceProfileLoadingItems from 'src/components/invoiceProfile/InvoiceProfileLoadingItems';
import InvoiceProfileCard from 'src/components/invoiceProfile/InvoiceProfileCard';
import api from 'src/services/api';
const SetupWizardInvoiceProfile = ({ selectedProfile, setSelectedProfile, setInvoiceProfileData }) => {

    const invoiceProfiles = useInvoiceProfiles()

    const [showModal, setShowModal] = React.useState(false);

    const [actionLoading, setActionLoading] = useState<Record<string, boolean>>({});

    const { t } = useLanguage();

    const { token } = theme.useToken()

    const message = App.useApp().message;

    const [editing, setEditing] = useState<any | null>(null);



    const collapseItems = [
        {
            key: '1',
            label: t('WHATS_MEANING_OF_INVOICE_PROFILE'),
            children: t('WHATS_MEANING_OF_INVOICE_PROFILE_DESC')
        },
    ]
    const handleEditProfile = (item) => {
        setEditing(item)
        setShowModal(true)
     }
    const handleSelectProfile = async (id) => {
        setSelectedProfile(id)
        const profile = invoiceProfiles.invoiceProfiles.find(p => p.Id === id)
        if (profile) {
            setInvoiceProfileData(profile)
        }
    }
    const handleDeleteProfile = async (id: number) => {
        setActionLoading((prev) => ({ ...prev, [`delete-${id}`]: true }));
        try {
            await api.delete(`/invoice-info/${id}`);
            invoiceProfiles.fetchInvoiceProfiles();


            message.success(t('INVOICE_PROFILE_DELETED'));
        } catch (e: any) {
            console.error('Invoice profile delete error:', e);
            message.error(e?.response?.data?.message || t('INVOICE_PROFILE_DELETE_FAILED'));
        } finally {
            setActionLoading((prev) => ({ ...prev, [`delete-${id}`]: false }));
        }
    };

    const actionLoadingProfiles = {}


    useEffect(() => {
        invoiceProfiles.fetchInvoiceProfiles()
    }, [])


    if (invoiceProfiles.loading) {
        return (<InvoiceProfileLoadingItems loading={invoiceProfiles.loading} />)
    }

    return (
        <>


            <InvoiceForm onClose={() => setShowModal(false)} open={showModal} loading={false} editing={editing} reload={() => invoiceProfiles.fetchInvoiceProfiles()} />

            <Alert banner type='info' message={t('SETUP_WIZARD_INVOICE_PROFILE_ALERT')} style={{ marginBottom: 20 }} icon={<InfoCircleOutlined />} />


            {!invoiceProfiles.invoiceProfiles.length ?


                <Card>
                    <Result
                        status="info"
                        title={t("NO_INVOICE_PROFILES")}
                        subTitle={t("NO_INVOICE_PROFILES_DESC")}
                        extra={
                            <Button type="primary" onClick={() => setShowModal(true)}>
                                {t("CREATE_INVOICE_PROFILE")}
                            </Button>
                        }
                    />
                </Card>

                : <>


                    {invoiceProfiles.invoiceProfiles.map((item) => (<InvoiceProfileCard actionLoading={actionLoading}

                        cardStyle={
                            selectedProfile === item.Id ? { border: '1px solid ' + token.colorPrimaryActive } : {}
                        }

                        handleDelete={handleDeleteProfile}
                        handleEdit={handleEditProfile}
                        handleSelect={handleSelectProfile}
                        item={item}
                        loading={invoiceProfiles.loading}
                        selectedId={selectedProfile} />))}

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

                        <Typography.Text type='secondary' style={{ marginTop: 20 }}>{t('OR')}</Typography.Text>
                        <Button style={{ marginTop: 10 }} type="dashed" onClick={() => setShowModal(true)}>
                            {t("NEW_CREATE_INVOICE_PROFILE")}
                        </Button>
                    </div>



                </>

            }



            <Collapse items={collapseItems} style={{ marginTop: 20 }} />
        </>
    )
}

export default SetupWizardInvoiceProfile